import { useState } from "react";
import { DragDropContext } from "@hello-pangea/dnd";
import { Reshaped, View } from "reshaped";
import {
  Certificates,
  Contact,
  Header,
  IntroBody,
  ListLenguaje,
  Works,
} from "./components";
import "reshaped/themes/reshaped/theme.css";
import { listWorks, listCertificate, listaTecnologias, reoder } from "./utils";

export const App = () => {
  
  const initialStateDarkMode =
    localStorage.getItem("theme") === "dark" ||
    (!("theme" in localStorage) &&
      window.matchMedia("(prefers-color-scheme: dark)").matches);

  const [darkMode, setDarkMode] = useState(initialStateDarkMode);
  const [languages, setLanguage] = useState(listaTecnologias);

  const handleDragEnd = (result: any) => {
    const { destination, source } = result;
    if (!destination) return;
    if (
      source.index === destination.index &&
      source.droppableId === destination.droppableId
    )
      return;

    switch (result.source.droppableId) {
      case "lenguages":
        setLanguage((prevTasks: any) =>
          reoder(prevTasks, source.index, destination.index)
        );
        break;
    }
  };

  const handleChangedTheme = () => setDarkMode(!darkMode);

  return (
    <Reshaped theme="reshaped">
      <View>
        <Header changeThema={handleChangedTheme} isDark={darkMode} />
        <IntroBody isDark={darkMode} />

        <View padding={10} gap={10} divided>
          <DragDropContext onDragEnd={handleDragEnd}>
            <ListLenguaje list={languages} />
          </DragDropContext>

          <Works list={listWorks} />
          <Certificates list={listCertificate} />
          <Contact />
        </View>
      </View>
    </Reshaped>
  );
};
